/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letter_LabelInputs */

const en_cover_letter_label = /** @type {(inputs: Cover_Letter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover Letter`)
};

const de_cover_letter_label = /** @type {(inputs: Cover_Letter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anschreiben`)
};

/**
* | output |
* | --- |
* | "Cover Letter" |
*
* @param {Cover_Letter_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cover_letter_label = /** @type {((inputs?: Cover_Letter_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letter_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letter_label(inputs)
	return en_cover_letter_label(inputs)
});